var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2024 Eduardo Robles <edu@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { Switch } from "@mui/material";
import { useEditController } from "react-admin";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { useTranslation } from "react-i18next";
var SettingsTemplatesStyles = {
    Wrapper: styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        display: flex;\n        flex-direction: column;\n    "], ["\n        display: flex;\n        flex-direction: column;\n    "]))),
    Content: styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n        display: flex;\n        width: 239px;\n        align-items: center;\n        justify-content: space-between;\n    "], ["\n        display: flex;\n        width: 239px;\n        align-items: center;\n        justify-content: space-between;\n    "]))),
    Text: styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n        text-transform: capitalize;\n    "], ["\n        text-transform: capitalize;\n    "]))),
};
export var SettingsTemplates = function () {
    var _a, _b;
    var tenantId = useTenantStore()[0];
    var t = useTranslation().t;
    var _c = useEditController({
        resource: "sequent_backend_tenant",
        id: tenantId,
        redirect: false,
        undoable: false,
    }), record = _c.record, save = _c.save, isLoading = _c.isLoading;
    var _d = useState({
        mail: ((_a = record === null || record === void 0 ? void 0 : record.settings) === null || _a === void 0 ? void 0 : _a.mail) || true,
        sms: ((_b = record === null || record === void 0 ? void 0 : record.settings) === null || _b === void 0 ? void 0 : _b.sms) || false,
    }), setting = _d[0], setSetting = _d[1];
    var handleToggle = function (method) {
        var _a;
        var updatedSetting = __assign(__assign({}, setting), (_a = {}, _a[method] = !setting[method], _a));
        setSetting(updatedSetting);
        if (save) {
            save({
                settings: __assign(__assign({}, ((record === null || record === void 0 ? void 0 : record.settings) ? record.settings : {})), { mail: updatedSetting.mail, sms: updatedSetting.sms }),
            });
        }
    };
    useEffect(function () {
        var _a, _b;
        if (record.settings) {
            setSetting({
                mail: ((_a = record === null || record === void 0 ? void 0 : record.settings) === null || _a === void 0 ? void 0 : _a.mail) || true,
                sms: ((_b = record === null || record === void 0 ? void 0 : record.settings) === null || _b === void 0 ? void 0 : _b.sms) || false,
            });
        }
    }, [record]);
    if (isLoading)
        return null;
    return (_jsx(SettingsTemplatesStyles.Wrapper, { children: Object.keys(setting).map(function (method) { return (_jsxs(SettingsTemplatesStyles.Content, { children: [_jsx(SettingsTemplatesStyles.Text, { children: t("electionTypeScreen.common.".concat(method)) }), _jsx(Switch, { disabled: true, checked: (setting === null || setting === void 0 ? void 0 : setting[method]) || false, onChange: function () { return handleToggle(method); } })] }, method)); }) }));
};
var templateObject_1, templateObject_2, templateObject_3;
